import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！请查看您的邮箱确认。');
      return;
    }
    setStatus('loading');
    try {
      const formData = new FormData(form);
      if (honeypot) formData.delete('phone_alt');
      const response = await fetch('https://readdy.ai/api/form/d9u01378l97n3eas3eng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！请查看您的邮箱确认。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
        setStatus('error');
        setMessage(serverMsg.includes('spam') || serverMsg.includes('form data is spam')
          ? '提交失败，请稍后再试。'
          : serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-secondary-900">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-5 rounded-full bg-accent-500/20">
          <i className="ri-mail-send-line text-xl md:text-2xl text-accent-400"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅资讯更新
        </h2>
        <p className="text-sm md:text-base text-foreground-300 mb-8 max-w-lg mx-auto">
          第一时间获取亚洲一级日本最新内容推荐与精选资讯，不错过任何精彩内容。
        </p>

        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="w-full sm:flex-1 px-4 py-3 rounded-lg bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-foreground-400 text-sm focus:outline-none focus:border-accent-400 transition-colors duration-200"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="spam-catcher"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-lg font-medium text-sm transition-all duration-200 disabled:opacity-60 whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-400">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-400">{message}</p>
        )}
      </div>
    </section>
  );
}